//
//


module.exports = {
  currencyDisplay,
  doubleDisplay,
  noneAbsDoubleDisplay,
  rmCamma,
  round3
}

function currencyDisplay(num) {
  if (!num || 0) {
    return 0
  } else {
    num = Number(num).toFixed(0);
    return Number(num).toLocaleString('en');
  }
}

function doubleDisplay(num) {
  let _return;
  if (!num || 0) {
    return 0
  } else {
    // _return = Math.abs(num);
    _return = Math.abs(num).toFixed(4);
    _return = Number(_return).toLocaleString('en');
    _return = String(_return).replace('.', '/');
    return _return
  }
}

function noneAbsDoubleDisplay(num) {
  let _return;
  if (!num || 0) {
    return 0
  } else {
    _return = num.toFixed(4);
    _return = Number(_return).toLocaleString('en');
    _return = String(_return).replace('.', '/');
    return _return
  }
}

function rmCamma(num) {
  let _return;
  if (!num || 0) {
    return 0
  } else {
    _return = String(num).replace(/,/g, '');
  }
  return Number(_return)
}

function round3(num) {
  return Math.round(Number(num) * 1000) / 1000
  // return Math.ceil(Number(num) * 1000) / 1000
}
